// extracted by mini-css-extract-plugin
module.exports = {"root":"AddTileButton_root__25RjW","rootSmall":"AddTileButton_rootSmall__3Djhk"};